import { call, put, select, takeLatest } from 'typed-redux-saga'
import { errorHandler } from 'Modules'
import { RequestParams, ResponseCatalog } from 'Models'
import {
	ProfileOrganizationNS,
	profileOrganizationSlice,
	ProfileOrganization,
	profileOrganizationSelectors,
	profileOrganizationApi,
} from 'Pages/profileOrganization'

function* getList(action: ProfileOrganizationNS.GetList) {
	try {
		yield* put(profileOrganizationSlice.actions.setIsLoading(true))
		const { params, clear, callback } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(profileOrganizationSlice.actions.clearAll())
		}
		const res = yield* call(profileOrganizationApi.getAll, requestParams)
		const profileOrganizations = new ResponseCatalog<ProfileOrganization>(res)
		if (!clear) {
			const oldProfileOrganizations = yield* select(profileOrganizationSelectors.getEntries)
			profileOrganizations.entries = oldProfileOrganizations.concat(res.entries)
		}
		yield* put(profileOrganizationSlice.actions.setList(profileOrganizations))
		yield* put(profileOrganizationSlice.actions.setRequestParams(requestParams))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(profileOrganizationSlice.actions.setIsLoading(false))
	}
}

function* getOne(action: ProfileOrganizationNS.GetOne) {
	try {
		yield* put(profileOrganizationSlice.actions.setIsLoading(true))
		const res = yield* call(profileOrganizationApi.getOne, action.payload)
		yield* put(profileOrganizationSlice.actions.setOne(res))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(profileOrganizationSlice.actions.setIsLoading(false))
	}
}

function* getAllDocument(action: ProfileOrganizationNS.GetAllDocument) {
	try {
		yield* put(profileOrganizationSlice.actions.setIsLoading(true))
		const res = yield* call(profileOrganizationApi.getAllDocument, action.payload)
		yield* put(profileOrganizationSlice.actions.setAllDocument(res))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(profileOrganizationSlice.actions.setIsLoading(false))
	}
}

export function* profileOrganizationSaga() {
	yield* takeLatest(profileOrganizationSlice.actions.getList.type, getList)
	yield* takeLatest(profileOrganizationSlice.actions.getOne.type, getOne)
	yield* takeLatest(profileOrganizationSlice.actions.getAllDocument.type, getAllDocument)
}
